module.exports = __webpack_public_path__ + "img/Icon3.c692b5cd.svg";